export default __webpack_public_path__ + "static/media/tiktok-white.ca062340.svg";